import LanguageIcon from '@mui/icons-material/Language';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import i18n from 'i18next';
import { supportedLanguageList } from 'locales';
import { MouseEvent, useState } from 'react';
import { useSDK } from 'stores';

const LanguageDropdownList = () => {
	const { sdk } = useSDK();
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
	const open = Boolean(anchorEl);
	const handleClick = (event: MouseEvent<HTMLElement>) => {
		setAnchorEl(event.currentTarget);
	};
	const handleClose = () => {
		setAnchorEl(null);
	};
	const highlightCurrentLanguage = (value: string) => {
		return value === i18n.resolvedLanguage;
	};

	return (
		<>
			<IconButton
				edge="start"
				aria-label="more"
				id="language-dropdown-button"
				aria-controls={open ? 'language-dropdown-menu' : undefined}
				aria-expanded={open ? 'true' : undefined}
				aria-haspopup="true"
				onClick={handleClick}
				disableRipple
				sx={{
					color: 'primary.main',
				}}
			>
				<LanguageIcon />
			</IconButton>
			<Menu
				id="language-dropdown-menu"
				MenuListProps={{
					'aria-labelledby': 'language-dropdown-button',
				}}
				anchorEl={anchorEl}
				anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
				transformOrigin={{ vertical: 'top', horizontal: 'right' }}
				open={open}
				onClose={handleClose}
				sx={{
					mt: 0.5,
				}}
			>
				{Object.keys(supportedLanguageList).map((value) => (
					<MenuItem
						key={value}
						selected={highlightCurrentLanguage(value)}
						sx={{
							pl: 2,
							pr: 3,
						}}
						onClick={() => {
							handleClose();
							if (sdk) sdk.setLanguage(value.replace('_', '-'));
							i18n.changeLanguage(value).then();
						}}
					>
						{supportedLanguageList[value]}
					</MenuItem>
				))}
			</Menu>
		</>
	);
};

export default LanguageDropdownList;
